// extracted by mini-css-extract-plugin
export var badge = "video-module--badge--lWywl";
export var badges = "video-module--badges--EUwBY";
export var player = "video-module--player--fnThG";
export var playerWrapper = "video-module--playerWrapper--iHPVE";
export var videos = "video-module--videos--doORP";